import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractFascia} from "../../abstract-fascia";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-inline-fascia",
    styleUrls: ["./inline-fascia.component.scss"],
    templateUrl: "./inline-fascia.component.html"
})
export class FUIInlineFasciaComponent extends FUIAbstractFascia {
}
